
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiYnJ5YW4tYXQtcmFpbiIsImEiOiJjbGNmYXFldXc0dGR2M3BwOTU1cGdkbmYwIn0.U0UT74OmivX0M3VkzU2eSA';
